import { PageLayout } from '~/components/PageLayout/PageLayout';
import { Button } from '~/components/Button/Button';
import { Fragment } from 'react/jsx-runtime';
import { Link } from 'react-router';

export function Page() {
  return (
    <Fragment>
      <PageLayout.Heading text="Lösenordet återställt!" />

      <p style={{ marginBottom: 'var(--size-4)' }}>
        Ditt lösenord är nu återställt, du kan nu logga in med ditt nya lösenord.
      </p>

      <Link to="/auth/sign-in">
        <Button type="button">Logga in</Button>
      </Link>
    </Fragment>
  );
}
